export const MARKET_SAVE = 'MARKET_SAVE';
export const MARKET_CLEAR = 'MARKET_CLEAR';